export enum IamCredentialsActionTypes {
    SET_IAM_USER = "SET_IAM_USER",
    REMOVE_IAM_USER = "REMOVE_IAM_USER"
}